import React, { useState, forwardRef, useImperativeHandle } from 'react';
import * as General from '../General/General';
import * as rsuite from 'rsuite'
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Delete = forwardRef((Props, ref) => {

    //#region Const 

    const toaster = rsuite.useToaster();
    const [Page, setPage] = useState(0);
    const [DeleteModel, setDeleteModel] = useState(0);
    const [Id, setId] = useState("");
    const [Title, setTitle] = useState("");

    //#endregion

    //#region Handlers


    //#endregion

    //#region Methods

    useImperativeHandle(ref, () => ({

        Get(page, id, title) {
            setPage(page);
            setId(id);
            setTitle(title);
            setDeleteModel(true);
        }
    }
    ))



    const Delete = () => {
        if (Page == 0)
            DeleteRole();
        if (Page == 1)
            DeleteUser();
        if (Page == 3)
            DeleteProvinceCity();
        if (Page == 4)
            DeleteProductGroup();
        if (Page == 5)
            DeleteProductBrand();
        if (Page == 6)
            DeleteProduct();
        if (Page == 10)
            DeleteFiscalYear();
        if (Page == 11)
            DeleteStoreRoom();
        if (Page == 14)
            DeleteTransfer();
        if (Page == 16)
            DeleteBuyOrder();
        if (Page == 20)
            DeleteSuggestion();
        if (Page == 23)
            DeleteBank();
        if (Page == 24)
            DeletePOS();
        if (Page == 25)
            DeleteFund();
        if (Page == 26)
            DeleteCheckBook();
        if (Page == 27)
            DeletePreReciept();
        if (Page == 30)
            DeleteDocSetting();
        if (Page == 41)
            DeleteInventoryCounting();
        if (Page == 59)
            DeleteBasket();


    }


    const DeleteRole = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/Role/Delete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteProvinceCity = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/ProvinceCity/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }
    const DeleteProductGroup = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/ProductGroup/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }


    const DeleteProductBrand = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/ProductBrand/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteProduct = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/Product/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteFiscalYear = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/FiscalYear/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteStoreRoom = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/StoreRoom/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteBuyOrder = () => {
        var data = {
            "Id": Id,
            "Code": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/BuyOrder/DeleteHeader",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteUser = () => {
        var data = {
            "Id": Id,
            "FirstName": Title,
            "LastName": ""
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/User/UpdateIsDeleted",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteSuggestion = () => {
        var data = {
            "Id": Id,
            "Title": Title,
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/SuggestionProduct/Delete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteBank = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/Bank/Delete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeletePOS = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/POS/Delete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteFund = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/Fund/UpdateIsDelete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteDocSetting = () => {
        var data = {
            "Id": Id,
            "Comment": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/DocSetting/UpdateIsDelete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteCheckBook = () => {
        var data = {
            "Id": Id,
            "Title": Title
        };
        var config = {
            method: "post",
            url: General.ApiRoute() + "/CheckBook/Delete",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'ApiKey': General.APIKey()
            },
            data: data
        };
        trackPromise(
            axios(config)
                .then(function (response) {

                    if (response.data == "OK") {
                        Props.onSubmit()
                        setDeleteModel(false);
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حدف شده است.")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(response.data)), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeletePreReciept = () => {
        var RequestOptions = {
            data: {
                "Id": Id,
                "Price": Title
            },
            url: General.ApiRoute() + "/PreReciept/UpdateIsDeleted",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                        Props.onSubmit()
                        setDeleteModel(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const DeleteTransfer = () => {
        var RequestOptions = {
            data: {
                "Id": Id,
                "Price": Title
            },
            url: General.ApiRoute() + "/PreReciept/UpdateIsDeleted",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                        Props.onSubmit()
                        setDeleteModel(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const DeleteInventoryCounting = () => {
        var RequestOptions = {
            data: {
                "Id": Id,
                "Price": Title
            },
            url: General.ApiRoute() + "/InventoryCounting/Delete",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                        Props.onSubmit()
                        setDeleteModel(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const DeleteBasket = () => {
        var RequestOptions = {
            data: {
                "Id": Id,
                "Code": Title
            },
            url: General.ApiRoute() + "/Basket/Basket_Delete",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                        Props.onSubmit()
                        setDeleteModel(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }




    const CloseDeleteModal = () => {
        setDeleteModel(false);
    }

    //#endregion

    return (

        <rsuite.Modal open={DeleteModel} onClose={CloseDeleteModal} style={{ "zIndex": 10000 }}>
            <rsuite.Modal.Header>
                <rsuite.Modal.Title><b>حذف اطلاعات</b></rsuite.Modal.Title>
            </rsuite.Modal.Header>
            <rsuite.Modal.Body>
                <div className="mt-3 Font15">

                    آیا از حذف اطلاعات اطمینان دارید؟!
                </div>
            </rsuite.Modal.Body>
            <rsuite.Modal.Footer>
                <rsuite.Button appearance="primary" color="red" onClick={Delete}>
                    بلی
                </rsuite.Button>
                <rsuite.Button appearance="subtle" onClick={CloseDeleteModal}>
                    خیر
                </rsuite.Button>
            </rsuite.Modal.Footer>
        </rsuite.Modal>

    )
})

export default Delete;